import _ from 'lodash';
import Payment from 'payment';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { Field, change } from 'redux-form';
import config from 'src/appConfig';
import { TextFieldWrapper } from 'src/components';
import { Grid, Stack } from 'src/components/matchbox';
import { formatCardTypes } from 'src/helpers/billing';
import { getCreditCardType } from 'src/helpers/getCreditCardType';
import { cardExpiry, required } from 'src/helpers/validation';

/**
 * This component will register the following redux-form fields
 * card.number
 * card.name
 * card.expCombined
 * card.securityCode
 */
export class PaymentForm extends Component {
  componentDidMount() {
    const types = Payment.getCardArray();
    // Formats strings for our api (the ones we accept)
    Payment.setCardArray(formatCardTypes(types));

    // Format these textfields on change
    Payment.formatCardNumber(ReactDOM.findDOMNode(this.cc));
    Payment.formatCardExpiry(ReactDOM.findDOMNode(this.expiry));
    Payment.formatCardCVC(ReactDOM.findDOMNode(this.cvc));
  }

  validateType(number) {
    const cardType = getCreditCardType(number);
    const allowedCards = _.map(config.cardTypes, 'apiFormat');

    if (allowedCards.includes(cardType)) {
      return undefined;
    }

    return `We only accept ${allowedCards.join(', ')}`;
  }

  render() {
    const { disabled } = this.props;
    return (
      <div>
        <Stack>
          <p>Credit Card</p>
          <Field
            label="Credit Card Number"
            name="card.number"
            ref={(input) => (this.cc = input)}
            component={TextFieldWrapper}
            validate={[required, this.validateType]}
            disabled={disabled}
            data-sensitive={true}
          />
          <Field
            label="Cardholder Name"
            name="card.name"
            component={TextFieldWrapper}
            validate={required}
            disabled={disabled}
            data-sensitive={true}
          />
          <Grid>
            <Grid.Column xs={6}>
              <Field
                label="Expiration Date"
                name="card.expCombined"
                ref={(input) => (this.expiry = input)}
                placeholder="MM / YY"
                component={TextFieldWrapper}
                validate={[required, cardExpiry]}
                disabled={disabled}
                data-sensitive={true}
              />
            </Grid.Column>
            <Grid.Column xs={6}>
              <Field
                label="Security Code"
                name="card.securityCode"
                ref={(input) => (this.cvc = input)}
                placeholder="CVV/CVC"
                component={TextFieldWrapper}
                validate={required}
                disabled={disabled}
                data-sensitive={true}
              />
            </Grid.Column>
          </Grid>
        </Stack>
      </div>
    );
  }
}

export default connect(null, { change })(PaymentForm);
